/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Dashboard_Dev_ActivityInputs */



/**
* | output |
* | --- |
* | "Developer Activity" |
*
* @param {Menu_Dashboard_Dev_ActivityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const menu_dashboard_dev_activity = /** @type {((inputs?: Menu_Dashboard_Dev_ActivityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Dashboard_Dev_ActivityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Developer Activity")
});